import { LIVE_REACTION_COLLECTION } from "../../../AppConstants/CollectionConstants";

import { firestore } from "../../../firebase/firebase";

let liveReactionListenerRef = null;

const attachLiveReactionListener = (
  webinarId,
  callback = () => console.log("noFunFound")
) => {
  const ref = firestore.collection(LIVE_REACTION_COLLECTION).doc(webinarId);
  liveReactionListenerRef = ref.onSnapshot(
    (query) => {
      if (!query.exists) {
        callback(null);
        return;
      }
      let _data = query.data();
      callback(_data);
    },
    (err) => {
      callback(null, err);
    }
  );
};

const removeLiveReactionListener = () => {
  if (liveReactionListenerRef) {
    liveReactionListenerRef();
  }
};

const get = {
  attachLiveReactionListener,
  removeLiveReactionListener,
};

export default get;
